import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "fs18 fw600" }
const _hoisted_4 = { class: "fs12 mt2" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.vrm.dateListDic)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.vrm.dateListDic, (_dateDic, _datekey) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "w100 pointer mt10 mb10 padw10 text-left with_shadow hoverResetShadow rad10 hoverGrey hoverLgreyBg",
              key: _datekey,
              onClick: ($event: any) => (_ctx.showFilterSuggestedDate(_dateDic))
            }, [
              _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.CalendarUtil.toJpFormatDate(_dateDic.start_time)), 1),
              _createElementVNode("div", _hoisted_4, _toDisplayString(_dateDic.timeNum) + "件の提案があります（" + _toDisplayString(_ctx.CalendarUtil.toHourMin(_dateDic.start_time)) + "以降） ", 1),
              _hoisted_5
            ], 8, _hoisted_2))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}